export function formatMetricLabel(metric: string): string {
    const parts = metric.split(".");

    const formatPart = (part: string) => {
        return part
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    if (parts.length === 1) {
        return formatPart(parts[0]);
    }

    return parts.map(formatPart).join(" - ");
}
